import { FormControl, FormErrorMessage } from '@chakra-ui/react';
import { ResponsiveValue } from '@cmpsr/cml';
import { Divider, Flex, InlineAlert, PinInput, PinInputProps } from '@cmpsr/components';

type VerifyEmailBodyProps = PinInputProps & {
  isFormControlInvalid: boolean;
  pinInputProps: PinInputProps;
  formErrorMessage?: string;
  size: ResponsiveValue<'s' | 'm' | 'l'>;
};

export default function VerifyEmailBody({
  isFormControlInvalid,
  pinInputProps,
  formErrorMessage,
  size,
}: VerifyEmailBodyProps) {
  return (
    <>
      <Divider />
      <FormControl isInvalid={isFormControlInvalid}>
        <Flex w="100%" justifyContent="center">
          <PinInput type="number" aria-label="Insert the code" autoFocus otp size={size} {...pinInputProps}>
            {Array.from({ length: 6 }).map((_, index) => (
              <PinInput.Field key={index} />
            ))}
          </PinInput>
        </Flex>
        <FormErrorMessage>
          <InlineAlert status="error" mt="spacer-2">
            <InlineAlert.Icon />
            <InlineAlert.Message>{formErrorMessage}</InlineAlert.Message>
          </InlineAlert>
        </FormErrorMessage>
      </FormControl>
      <Divider />
    </>
  );
}
